<template>
  <div class="sell-point-base">
    <div class="sell-titlearea">
      <img :src="`${imgPath}/title_sellpoint.svg`" alt="">
    </div>
    <p class="sell-point-text">恋・仕事・出会い・人生…<br>さまざまな占いが</p>
    <p class="sell-point-text-big">占い放題！</p>
    <p class="sell-point-lead">＼2023年の運勢もお得に占える／</p>
    <div class="price_box">
      <div class="normal-price">
        <p class="normal-price_title">通常価格</p>
        <p class="price-text">{{formatPrice(nomalPrice)}}<span class="price_notice">(税込)</span></p>
      </div>
      <div class="arrow-box">
        <img :src="`${imgPath}arrow.svg`" alt="">
      </div>
      <div class="member-price">
        <p class="member-price_title">会員価格</p>
        <p class="member-price-text">{{formatPrice(memberPrice)}}<span class="member-price_notice">(税込)</span></p>
      </div>
    </div>
    <div class="banner_box">
      <img :src="`${imgPath}bottom_banner.png`" alt="" class="banner_img" @click="onBannerClick">
    </div>
  </div>
</template>

<script>
import BasicButton from './BasicButton'

export default {
  name: 'SellPoint',
  components: {BasicButton},
  props: {
    nomalPrice:{
      type:String,
      default:''
    },
    sbscUrl: {
      type: String,
    },
    memberPrice:{
      type:String,
      default:''
    },
  },
  data() {
    return {
      imgPath: '/static/img/yearluck/y2023/',
    }
  },
  mounted() {

  },
  methods: {
    onInducePurchaseClick() {
      this.$emit('btn-click')
    },
    formatPrice(val) {
      const price = String(val).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      return `￥${price}`
    },
    onBannerClick() {
      //location.href = this.sbscUrl
      location.href = '/'
    },
  }
}</script>

<style scoped lang="scss">
.sell-point-base{
  background: #fff;
  padding: 40px 24px;
}

.sell-titlearea{
  text-align: center;
}

.sell-point-text{
  font-weight: 600;
  font-size: 22px;
  line-height: 28px;
  color: #32373f;
  margin: 0;
  margin-bottom: 10px;
  text-align: center;

}

.sell-point-lead{
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  color: #32373f;
  margin: 0;
  margin-bottom: 10px;
  text-align: center;

}

.sell-point-text-big{
  font-weight: 600;
  font-size: 48px;
  line-height: 46px;
  text-align: center;
  color: #32373f;
  margin:0;
  margin-bottom: 8px;
}
.price_box {
  display: flex;
  justify-content: center;
  align-items: center;
}
.normal-price_title{
  background: #656D78;
  border-radius: 20px;
  color:#fff;
  text-align: center;
}
.member-price_title{
  background: #FF7497;
  border-radius: 20px;
  color:#fff;
  text-align: center;
}

.member-price-text{
  font-weight: 600;
  font-size: 26px;
  line-height: 20px;
  color: #32373F;

}

.member-price_notice{
  font-weight: 600;
  font-size: 26px;
  line-height: 20px;
  color: #32373F;
}
.price-text{
  font-weight: 600;
  font-size: 24px;
  line-height: 20px;
  color: #32373F;

}

.price_notice{
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #32373F;
}
.arrow-box{
  padding-top: 40px;
  margin: 0 6px;
}

.banner_box{
  width:100%;
  .banner_img{
    cursor: pointer;
    width: 100%;

  }
}


</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/YearLuck/y2023/partials/SellPoint.vue